// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    .budgetElement {
        width: 70%;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding: 20px 50px;
        background-color: white;

        label {
            font-size: 16px;
            font-weight: 500;
        }

        .form-control {
            box-shadow: none;
        }

        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #D5D5D5;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }

        /* select:focus {
            outline: none;
            border: none;
            box-shadow: none;
        } */

        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }
}

.account-placeholder {
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/WorkOrderManagement/CreateWorkOrder/workorder.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;QAEA;;;;WAIG;;QAEH;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".budgetContainer {\r\n    .budgetElement {\r\n        width: 70%;\r\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\r\n        border-radius: 5px;\r\n        padding: 20px 50px;\r\n        background-color: white;\r\n\r\n        label {\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .form-control {\r\n            box-shadow: none;\r\n        }\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #D5D5D5;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n        /* select:focus {\r\n            outline: none;\r\n            border: none;\r\n            box-shadow: none;\r\n        } */\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n}\r\n\r\n.account-placeholder {\r\n  font-size: 12px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
